module.exports = __webpack_public_path__ + "img/directory--icon.2625bb04.svg";